import { render, staticRenderFns } from "./SaleInvoiceTypesTable.vue?vue&type=template&id=41afca9e&scoped=true&"
import script from "./SaleInvoiceTypesTable.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceTypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41afca9e",
  null
  
)

export default component.exports